import { BoxShadowLarge, ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';
import { InvalidInputFocusStyle, InvalidInputStyle, ValidInputDisabledStyle } from '../../theme';

const SelectButtonStyling = css<{ $isInvalid?: boolean; isOpen?: boolean; placement?: string; disabled?: boolean }>`
    justify-content: space-between;
    background-color: ${ColorNeutralWhite};
    color: ${({ theme }) => theme.ColorTextPrimary};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.ColorBorderPrimary};
    align-items: center;
    border-radius: ${({ isOpen, placement, theme }) => {
        if (!isOpen) return theme.RadiusMedium || '0';
        switch (placement) {
            case 'bottom-start':
            case 'bottom-end':
                return `${theme.RadiusMedium} ${theme.RadiusMedium} 0 0`;
            case 'top-start':
            case 'top-end':
                return `0 0 ${theme.RadiusMedium} ${theme.RadiusMedium}`;
            default:
                return theme.RadiusMedium || '0';
        }
    }};


    &:hover {
        border-color: ${({ theme }) => theme.ColorBorderHover};
    }

    &:focus {
        border-color: ${({ theme }) => theme.ColorBorderFocus};
        outline-offset: 0;
        outline-width: 1px;
        
        ${({ isOpen }) =>
            isOpen &&
            css`
                border-color: transparent;
            `};
    }

    
    ${({ disabled }) => disabled && ValidInputDisabledStyle}

    ${({ $isInvalid }) =>
        $isInvalid &&
        css`
            &&,
            &&:hover {
                ${InvalidInputStyle};
            }

            &&:focus {
                ${InvalidInputFocusStyle};
            }
        `};


    ${({ isOpen }) =>
        isOpen &&
        css`
            box-shadow: ${BoxShadowLarge};
        `};
`;

export { SelectButtonStyling };
